export default "__VITE_ASSET__DKMqPqea__"